module.exports = __webpack_public_path__ + "static/img/qdhf2.f34e84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qdhf2.jpg
// module id = /6k0
// module chunks = 0